




import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

declare global {
    interface Window { onloadCallback: Function; }
    interface Window { grecaptcha: any; }
}

@Component({})
export default class Captcha extends Vue {
    @Prop() siteKey?: string;

    mounted() {
        this.createApiScript();

        window.onloadCallback = () => {
            window.grecaptcha.render('g-recaptcha', {
                'sitekey' : this.siteKey
            });
        };
    }

    private createApiScript(): void {
        let scriptTag = document.createElement('script');
        scriptTag.src = "//www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        if (firstScriptTag && firstScriptTag.parentNode) {
            firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        }
    }
}
